export const en = {
  // Navbar
  _hello: "_hello",
  "_about-me": "_about-me",
  _projects: "_projects",
  _blog: "_blog",
  _contact: "_contact",
  "english-version": "english-version",
  "german-version": "german-version",
  "work-reference": "work-reference",

  // Home
  HomeGreeting: "Hello, World!",
  HomeName: "Ibrahim",
  HomeSurname: "Adebiyi",
  HomeBio:
    "I am a passionate Full-Stack JavaScript Developer with over 5 years of experience building modern, scalable, and high-performance web applications. I specialize in creating seamless user experiences while designing efficient and maintainable backend systems. My expertise spans across modern frontend frameworks such as React, Angular, Vue, and Next.js, where I focus on building responsive, intuitive interfaces with clean and reusable code. On the backend, I develop robust APIs and scalable server-side solutions using Node.js, NestJS, and Express. I work extensively with TypeScript and JavaScript, ensuring type-safe, maintainable, and high-quality codebases. My database experience includes both SQL and NoSQL databases, such as PostgreSQL, MongoDB, and Convex.",
  HomeTypewriter: ["FullStack-Developer", "Freelancer", "Problem-Solver", "AI-Enthusiast"],
  HomeCodeTitle: "hello.js",
  HomeCodeDev: "developer",
  HomeCodeName: "Ibrahim Adebiyi",
  HomeCodeRole: "Full-stack Engineer",
  HomeCodeStack: ["Javascript", "Typescript", "Node"],
  HomeCodeAvailable: "true",

  // About Me
  AboutMeTitle: "About Me",
  AboutMeSub: "A glimpse into my journey and professional experience.",
  ExpTitle: "Experience",
  SkillsTitle: "Technical Skills",
  CertTitle: "Certifications",
  AboutMeDesc:
    "As a dedicated Full-Stack Engineer, I have spent the last 5+ years mastering the art of building scalable and user-centric web applications. My journey began with a curiosity for how things work on the web, and it has evolved into a career where I bridge the gap between technical complexity and intuitive user experiences. I thrive in agile environments, collaborating with cross-functional teams to solve real-world problems and deliver high-impact solutions.",
  AboutMeLong:
    "I’m a software engineer with over five years of professional experience building and maintaining production web applications. My primary focus is frontend development using React, Next, Angular, Vue, and TypeScript, but I also have practical backend experience working with Node.js and REST APIs.\n\nAt tech11 GmbH, I contribute to the development of a large insurance platform used by thousands of users. My work includes building reusable UI components, improving frontend architecture, and optimizing performance for complex enterprise applications. I collaborate closely with product managers, designers, and backend engineers in an agile environment and regularly participate in code reviews and technical discussions to maintain high code quality.\n\nEarlier in my career, I worked on several web platforms including enterprise systems, internal management tools, and e-commerce applications. In addition to developing modern frontend interfaces, I have implemented and maintained backend services using Node.js, Express, and MongoDB, and have experience integrating frontend systems with REST APIs and GraphQL.\n\nI focus on building maintainable software, designing reusable components, and solving real engineering problems in production systems. My core stack includes Javascript, Typescript, React, Angular, TypeScript, Node.js, and modern web development tools.",
  SoftwareEngineer: "Software Engineer",
  FrontendFocus: "Software Engineer (Frontend Focus)",
  FullstackDev: "Frontend / Full-Stack Developer",
  FrontendDev: "Frontend Developer",
  Fulltime: "Full-time",
  Contract: "Contract",
  Present: "present",

  // Experience Details
  Exp_Weidmuller:
    "Developed and enhanced scalable, high-performance software systems using JavaScript/TypeScript with a focus on web technologies and Angular within an agile team, while analyzing business and technical requirements, contributing to software architecture and solution design, and integrating modern backend interfaces such as REST APIs and WebSocket-based services using current frameworks and best practices.",
  Exp_Tech11:
    "Develop and maintain a large-scale insurance platform used by thousands of users across multiple product teams. Designed and implemented reusable UI components and shared libraries that improved consistency and reduced duplicated code by ~30%. Contributed to the migration from Web Components to Angular with a scalable architecture. Implemented performance optimizations such as lazy loading and code splitting, improving load times by ~25%. Collaborate closely with product managers, UX designers, and backend engineers in an agile environment while participating in code reviews and pair programming to ensure high code quality.",
  Exp_Prunedge:
    "Built scalable and responsive web applications using React, Next.js, and TypeScript for enterprise and internal platforms. Implemented complex form workflows and modular frontend architectures that improved maintainability and development speed. Developed and maintained REST APIs with Node.js, Express, and MongoDB to support frontend functionality. Wrote frontend tests with React Testing Library and promoted best practices through regular code reviews. Also mentored 3–5 junior developers and helped improve team productivity and code quality.",
  Exp_FacilityBill:
    "Led the migration of a legacy monolithic Laravel application to a modern React-based frontend architecture. The transition improved application performance by approximately 30% and enabled faster feature development. Implemented new features, resolved critical bugs, and enhanced responsiveness across devices. Worked directly with stakeholders and users to understand requirements and improve the user experience through modern frontend practices.",
  Exp_Philometer:
    "Developed a modern e-commerce platform for pharmacies using React and Tailwind CSS. Implemented key features including product search, barcode-based product management, shopping cart functionality, and order workflows. Integrated frontend components with backend APIs and collaborated with backend developers to ensure reliable data flow. Focused on delivering a responsive, user-friendly interface and improving overall performance of the platform.",

  // Projects
  ProjectsTitle: "Projects",
  ProjectsSub: "A showcase of some of my personal and professional work.",
  ViewProject: "View Project",
  SourceCode: "Source Code",

  // Contact
  ContactTitle: "Contact Me",
  ContactSub: "Let's connect and discuss potential opportunities.",
  NameLabel: "_name:",
  EmailLabel: "_email:",
  MessageLabel: "_message:",
  SubmitButton: "submit-message",
  ContactSuccess: "Message sent! I will get back to you soon.",
  ContactFallback: "No endpoint configured yet. Opening your email client.",
  ContactError: "Could not send automatically. Opening email client.",
  BayernGermany: "Bayern Germany",
  FindMeAlsoIn: "find-me-also-in",
  Contacts: "contacts",
  SuccessTitle: "Thank you!",
  SuccessText: "Your message has been sent. I'll respond within 24 hours!",
  SendNewMessage: "send-new-message",
  NamePlaceholder: "John Doe",
  EmailPlaceholder: "john@example.com",
  MessagePlaceholder: "Let's build something together...",

  // Blog
  BlogPosts: "blog posts",
  BlogTitle: "Thoughts &",
  BlogTitleAccent: "Articles",
  BlogSub: "Read recent ideas and share comments.",
  CreateBlogPost: "create-blog-post",
  ExitAdmin: "exit-admin",
  AdminAccess: "admin-access",
  LoadingPosts: "Loading blog posts...",
  Read: "read",
  Edit: "edit",
  AdminConnected: "Admin connected",
  AdminDisconnected: "Admin disconnected",
  EnterAdminKey: "Enter admin key",
  PostNotFound: "Post not found.",
  BackToBlog: "back-to-blog",
  Back: "back",
  EditPost: "edit-post",
  Comments: "Comments",
  AddComment: "add-comment",
  LoadingComments: "Loading comments...",
  NoComments: "No comments yet. Be the first to comment.",
  YourName: "Your name",
  WriteComment: "Write a comment...",
  CommentAdded: "Comment added.",
  EnterComment: "Please enter your a comment.",
  Anonymous: "Anonymous",
  LoadingPost: "Loading post...",
  AdminRequired: "Admin access is required to create/edit blog posts.",
  UnlockAdmin: "unlock-admin",
  AdminKeyRequired: "Admin key is required.",
  FillRequiredFields: "Please fill title, excerpt and content.",
  PostCreated: "Blog post created successfully.",
  PostUpdated: "Blog post updated successfully.",
  ValidImage: "Please upload a valid image file.",
  SavePost: "save-post",
  UpdatePost: "update-post",
  DeletePost: "delete-post",
  DeleteConfirm: "Delete this post permanently?",
  PostDeleted: "Post deleted.",
  EditBlogPost: "Edit Blog Post",
  BlogNotConfigured: "Blog backend is not configured yet.",
  BlogHint: "Add REACT_APP_CONVEX_URL to your .env and run Convex.",

  // Footer
  MadeWith: "Made with",
  By: "by",
  FooterCredits: "Built with React & Convex",
  FindMeOn: "find me on:",

  // Common
  Loading: "Loading...",
  Error: "Error occurred.",

  // Personal Info Labels
  PersonalInfo: "personal-info",
  Interests: "// interests",
  SkillsTab: "_skills",
  ExperienceTab: "_experience",
  CertsTab: "_certifications",

  // Interests
  Interest_WebDev: "Web Development",
  Interest_OpenSource: "Open Source",
  Interest_Web3: "Web3 / Blockchain",
  Interest_Prompting: "Prompting",
  Interest_AI: "AI",
  Interest_Football: "Football",

  // Dates
  Mon: "Mon",
  Tue: "Tue",
  Wed: "Wed",
  Thu: "Thu",
  Fri: "Fri",
  Sat: "Sat",
  Sun: "Sun",
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  May: "May",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Oct",
  Nov: "Nov",
  Dec: "Dec",

  // Project descriptions
  Proj_LMS_Name: "Learning Management Solution",
  Proj_LMS_Desc: "Learning Management Solution for Delta State Nigeria",
  Proj_MIPAD_Name: "MIPAD",
  Proj_MIPAD_Desc: "Event registration and tracking platform for MIPAD",
  Proj_Estate_Name: "Estate Management Solution",
  Proj_Estate_Desc: "Estate Management solution",
  Proj_Loan_Name: "Loan App",
  Proj_Loan_Desc: "Loan App for Stanbic IBTC",
  Proj_Citizen_Name: "Citizen Management",
  Proj_Citizen_Desc: "Citizen Management for OYO state",
  Proj_RMS_Name: "RMS",
  Proj_RMS_Desc: "Remote monitoring system (starsight)",
  Proj_Proworks_Name: "Proworks",
  Proj_Proworks_Desc: "Business Processing Automation System for OYO State",
  Proj_PollEasy_Name: "PollEasy",
  Proj_PollEasy_Desc:
    "A platform that helps to collect data and layer analytics to manage election.",
  Proj_Tech11_Name: "Tech11 insurance",
  Proj_Tech11_Desc:
    "T11 insurance platform is used for insurance management written in web component",
  Proj_NPI_Name: "Nigeria Poverty Index (NPI)",
  Proj_NPI_Desc:
    "Analysis of multidimensional poverty in Nigeria, including its composition and disaggregation across states and districts",
  Proj_HRMS_Name: "HR Management System API",
  Proj_HRMS_Desc:
    "Backend API for a Human Resource Management System supporting employee records, leave management, authentication, and payroll workflows. Built scalable REST APIs and handled data persistence and role-based access.",
  Proj_LMS_BE_Name: "Learning Management System Backend",
  Proj_LMS_BE_Desc:
    "Backend service for an LMS platform handling course management, student progress tracking, authentication, and content delivery. Designed REST APIs and integrated frontend applications with a scalable backend architecture.",
  Proj_Ecom_BE_Name: "E-commerce Platform API",
  Proj_Ecom_BE_Desc:
    "Backend services supporting a pharmacy e-commerce platform including product catalog management, cart operations, order processing, and API integration with frontend systems.",
};
